import { useTranslation } from 'react-i18next';

interface Ticker {
  label: string;
  value: string;
  tone: 'positive' | 'neutral' | 'caution';
}

/**
 * Hairline ticker that runs across the top of the hero. Surfaces a
 * handful of "this is what PlyEZ actually does for you" datapoints —
 * adapt the values to be live in production via SSE later.
 */
export function TickerBar() {
  const { t } = useTranslation();

  const items: Ticker[] = [
    { label: t('ticker.invoicesProcessed'), value: '12,481', tone: 'positive' },
    { label: t('ticker.avgOcrAccuracy'),    value: '97.2 %', tone: 'positive' },
    { label: t('ticker.crossBorderRails'),  value: '130+',   tone: 'neutral' },
    { label: t('ticker.peppolMessages'),    value: '4,902',  tone: 'positive' },
    { label: t('ticker.medianApproval'),    value: '11 min', tone: 'positive' },
    { label: t('ticker.languagesShipped'),  value: '14',     tone: 'neutral' },
    { label: t('ticker.openSourceModels'),  value: '8',      tone: 'neutral' },
    { label: t('ticker.bonded'),            value: 'JP / EU / US', tone: 'neutral' },
  ];
  const loop = [...items, ...items];

  return (
    <div className="relative border-y border-border bg-card/40 backdrop-blur">
      <div className="overflow-hidden">
        <div className="flex animate-ticker whitespace-nowrap py-2 text-xs text-muted-foreground">
          {loop.map((it, i) => (
            <div key={i} className="flex items-center gap-3 px-6 shrink-0">
              <span className="uppercase tracking-[0.18em] text-[10px]">{it.label}</span>
              <span
                className={
                  'num font-semibold ' +
                  (it.tone === 'positive'
                    ? 'text-emerald-700'
                    : it.tone === 'caution'
                    ? 'text-warn-600'
                    : 'text-foreground')
                }
              >
                {it.value}
              </span>
              <span className="text-border" aria-hidden>•</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
